import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import contactUsImg1 from '../../assets/ContactUsPhotos/contactUsImg1.jpg';
import './ContactUs.css';

const ContactUs = () => {

  const [loadTime] = useState(Date.now());
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    clientType: '',
    message: '',
    website: '' 
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Honeypot check (Front-end)
    if (formData.website !== "") {
      alert("Message sent successfully!"); 
      return;
    }

    // 2. Time check
    const timeTaken = (Date.now() - loadTime) / 1000;
    if (timeTaken < 4) { 
      console.warn("Spam prevention: Submission too fast.");
      alert("Message sent successfully!");
      return;
    }

    try {
      const response = await fetch("https://www.hdpmg.com/send-contact-hdpmg.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData), 
      });

      const data = await response.json();

      if (data.success) {
        alert("Message sent successfully!");
        setFormData({ name: '', email: '', clientType: '', message: '', website: '' });
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Network error. Please try again later.");
    }
  };

  return (
    <div className="contact-page">
      <section 
        className="contact-hero" 
        style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5)), url(${contactUsImg1})` }}
      >
        <Container>
          <Row className="align-items-center justify-content-between">
            <Col lg={5} className="text-white mb-5 mb-lg-0">
              <div className='contact-us-info'>
                <span className="subtitle text-uppercase">Inquire</span>
                <h1 className="display-5 fw-bold mb-3">GET IN TOUCH</h1>
                <div className="contact-info-box mt-5">
                  <h4 className="fw-bold mb-3">Contact Information</h4>
                  <div className="d-flex flex-column gap-2">
                    <a href="tel:321-396-0111" className="contact-link">📞 321-396-0111</a>
                    <a href="mailto:Support@hdpmg.com" className="contact-link">✉️ Support@hdpmg.com</a>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg={6}>
              <div className="contact-form-card">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Your name *</Form.Label>
                    <Form.Control 
                      type="text" 
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name" 
                      required 
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Email address *</Form.Label>
                    <Form.Control 
                      type="email" 
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="email@example.com" 
                      required 
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Client Type *</Form.Label>
                    <Form.Select 
                      name="clientType"
                      value={formData.clientType}
                      onChange={handleChange}
                      required
                    >
                      <option value="">(Select type)</option>
                      <option value="owner">Property owner</option>
                      <option value="prospective">Prospective tenant</option>
                      <option value="client">Current client</option>
                      <option value="tenant">Current tenant</option>
                    </Form.Select>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Description *</Form.Label>
                    <Form.Control 
                      as="textarea" 
                      rows={4} 
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="How can we help you?" 
                      required 
                    />
                  </Form.Group>

                  {/* Honeypot: Apsolutno position over screen */}
                  <div style={{ position: 'absolute', left: '-9999px', top: '-9999px', opacity: 0 }} aria-hidden="true">
                    <label htmlFor="website">Do not fill this field</label>
                    <input 
                      type="text" 
                      id="website"
                      name="website"
                      autoComplete="off"
                      tabIndex="-1"
                      value={formData.website}
                      onChange={handleChange}
                    />
                  </div>

                  <Button type="submit" className="submit-btn px-5 py-2">SUBMIT</Button>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      
      <section className="contact-map-section w-100">
        <div className="container-fluid p-0">
          <div className="map-container" style={{ width: '100%', height: '450px', overflow: 'hidden' }}>
            <iframe
              title="HDPMG Office Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3505.518608827606!2d-81.3788!3d28.5383!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDMyJzE3LjkiTiA4McKwMjInNDMuNyJX!5e0!3m2!1sen!2sus!4v1620000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactUs;